import React from 'react';
import { ChangePasswordIcon } from 'common/Icons';
import { Form } from './components/Form';
import { useTranslation } from 'react-i18next';

export const MobileConfirmCode = () => {
  const { t } = useTranslation();

  return (
    <div className="md:hidden  grid grid-min-one">
      <div className="mx-auto mr-20 absolute top-0 left-0 ">
        <ChangePasswordIcon />
      </div>
      <div className="p-4 mt-36">
        <div className="mt-4">
          <h1 className="text-5xl font-bold text-L-gray-400">
            {t(`FormSide.ValidationCodeText`)}
          </h1>
          <Form />
        </div>
      </div>
    </div>
  );
};
